import { contactService } from '../services/contactService';

// Admin utilities for managing contact messages
export const adminUtils = {
  // Log all messages to console (for development)
  async logAllMessages() {
    try {
      const messages = await contactService.getAllMessages();
      console.log('=== ALL CONTACT MESSAGES ===');
      console.table(messages.map(msg => ({
        id: msg.id,
        name: msg.name,
        email: msg.email,
        category: msg.category,
        subject: msg.subject,
        status: msg.status,
        priority: msg.priority,
        timestamp: msg.timestamp?.toLocaleString() || 'N/A'
      })));
      
      // Log full details
      messages.forEach(msg => {
        console.group(`📧 Message from ${msg.name} (${msg.email})`);
        console.log('Subject:', msg.subject);
        console.log('Category:', msg.category);
        console.log('Priority:', msg.priority);
        console.log('Message:', msg.message);
        console.log('System Info:', msg.systemInfo);
        console.log('Timestamp:', msg.timestamp);
        console.groupEnd();
      });
      
      return messages;
    } catch (error) {
      console.error('Error logging messages:', error);
    }
  },

  // Get message statistics
  async getStats() {
    try {
      const stats = await contactService.getMessageStats();
      console.log('=== CONTACT MESSAGE STATISTICS ===');
      console.log('Total Messages:', stats.total);
      console.log('Recent (Last Week):', stats.recentCount);
      console.log('By Category:', stats.byCategory);
      console.log('By Status:', stats.byStatus);
      console.log('By Priority:', stats.byPriority);
      console.log('By User Type:', stats.byUserType);
      return stats;
    } catch (error) {
      console.error('Error getting stats:', error);
    }
  },

  // Get only new messages
  async getNewMessages() {
    try {
      const messages = await contactService.getMessagesByStatus('new');
      console.log(`=== ${messages.length} NEW MESSAGES ===`);
      messages.forEach(msg => {
        console.log(`📧 ${msg.name} (${msg.email}): ${msg.subject}`);
      });
      return messages;
    } catch (error) {
      console.error('Error getting new messages:', error);
    }
  },

  // Export messages as JSON (for backup)
  async exportMessages() {
    try {
      const messages = await contactService.getAllMessages(1000);
      const exportData = {
        exportDate: new Date().toISOString(),
        totalMessages: messages.length,
        messages: messages
      };
      
      // Create downloadable file
      const dataStr = JSON.stringify(exportData, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(dataBlob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `contact-messages-${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      console.log('Messages exported successfully');
      return exportData;
    } catch (error) {
      console.error('Error exporting messages:', error);
    }
  }
};

// Make it available globally for console access
if (typeof window !== 'undefined') {
  window.adminUtils = adminUtils;
}
